import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-down-arrow",
  "use": "icon-down-arrow-usage",
  "viewBox": "0 0 27.45 15.17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 27.45 15.17\" id=\"icon-down-arrow\"><defs><style>#icon-down-arrow .cls-1{fill:#010101;}</style></defs><g id=\"icon-down-arrow_Layer_2\" data-name=\"Layer 2\"><g id=\"icon-down-arrow_Layer_1-2\" data-name=\"Layer 1\"><path class=\"cls-1\" d=\"M12.71,14.75a1.44,1.44,0,0,0,2,0L27,2.47a1.44,1.44,0,0,0-2-2L13.73,11.68,2.47.42a1.44,1.44,0,0,0-2,2Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol